import React, { useEffect } from "react";
import styled, { keyframes } from 'styled-components';
import TeamNameAndBelongInput from "../Component/TeamNameAndBelongInput";

export default function MemberInfoModifyModal(props) {
  const {
    name,
    phone,
    birth,
    instaId,
    changeName,
    setChangeName,
    changePhone,
    setChangePhone,
    changeBirth,
    setChangeBirth,
    changeGender,
    setChangeGender,
    changeInstaId,
    setChangeInstaId,
    bloodType,
    changeBloodType,
    setChangeBloodType,
    onClickExit,
    onClickSave
  } = props;

  // 스크롤 제어 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  // 생년월일 입력시 숫자만 허용 //
  function onChangeBirth(value) {
    setChangeBirth(value.replace(/[^0-9]/g, ''));
  }

  return (
    <TopLevelWrapper>
      <ModalView>
        <TotalWrapper>
          <TitleWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>팀원 정보 변경</Text>
          </TitleWrapper>
          <TotalInputWrapper>
            <InputBoxWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>변경할 이름</Text>
              <TeamNameAndBelongInput value={changeName} setValue={setChangeName} placeholder={name}/>
            </InputBoxWrapper>
            <InputBoxWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>변경할 전화번호</Text>
              <TeamNameAndBelongInput value={changePhone} setValue={setChangePhone} placeholder={phone}/>
            </InputBoxWrapper>
            <InputBoxWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>변경할 생년월일 (YYMMDD 6자리)</Text>
              <TeamNameAndBelongInput value={changeBirth} setValue={onChangeBirth} placeholder={birth}/>
            </InputBoxWrapper>
            <InputBoxWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>변경할 성별</Text>
              <GenderWrapper>
                <GenderBox isClicked={changeGender === 'male'} onClick={() => setChangeGender('male')}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={changeGender === 'male' ? '#FFFFFF' : '#777777'} cursor='pointer'>남성</Text>
                </GenderBox>
                <GenderBox isClicked={changeGender === 'female'} onClick={() => setChangeGender('female')}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={changeGender === 'female' ? '#FFFFFF' : '#777777'} cursor='pointer'>여성</Text>
                </GenderBox>
              </GenderWrapper>
            </InputBoxWrapper>
            <InputBoxWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>인스타 아이디 (선택)</Text>
              <TeamNameAndBelongInput value={changeInstaId} setValue={setChangeInstaId} placeholder={instaId}/>
            </InputBoxWrapper>
            <InputBoxWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>기념품 옵션/사이즈 (선택)</Text>
              <TeamNameAndBelongInput value={changeBloodType} setValue={setChangeBloodType} placeholder={bloodType}/>
            </InputBoxWrapper>
          </TotalInputWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickExit}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>취소</Text>
            </ExitButton>
            <SaveButton onClick={onClickSave}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>저장하기</Text>
            </SaveButton>
          </ButtonWrapper>
        </TotalWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);

animation-name: ${startAnimation};
animation-duration: 0.5s;
animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 279px;

  border-radius: 10px;
  background-color: #2F2F32;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding-bottom: 20px;

  width: 90.33%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 100%;
`;

const TotalInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 100%;

  gap: 10px;
`;

const InputBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const GenderWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const GenderBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: calc(50% - 2px);
  height: 34px;

  border: ${props => props.isClicked ? '1px solid #5BD98A' : '1px solid #17171B'};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? '#6DD49E' : '#17171B'};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #17171B;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
